"use client";

import React from "react";
import BusinessSectionBlock from "./BusinessSectionBlock";
import rumah from "../../assets/rumah.png";

export default function BusinessSectionAccommodation() {
  return (
    <BusinessSectionBlock
      title="Start exploring Accommodation"
      description="You can feel comfortable when you stay overnight at Depok. We've curated selected accommodations and recommendations. Click more to see the choices that match your needs."
      image={rumah}
      href="/accommodation"
      reverse={true}
    />
  );
}